// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueAnalytics from 'vue-analytics'
import {sync} from 'vuex-router-sync'

import './assets/stylesheets/Fonts.css'
import './assets/mdb/sass/mdb.scss'
import App from './App'
import store from './store'
import router from './router'
import {analyticsConfig, initializeAnalytics} from './analytics'

// Configure sync between the router state and the Vuex store
sync(store, router)

Vue.use(VueAnalytics, {
  id: store.getters.googleAnalyticsId,
  samepleRate: store.getters.googleAnalyticsSampleRate,
  siteSpeedSampleRate: store.getters.googleAnalyticsSpeedSampleRate,
  ...analyticsConfig
})

/* eslint-disable no-new */
window.vm = new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App },
  beforeCreate: initializeAnalytics
})



// WEBPACK FOOTER //
// ./src/main.js